import type { IconProps } from './types';

export function Jaqueta({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 68 Q92 64 104 68 L104 48 Q104 44 112 44 L144 44 Q152 44 152 48 L152 68 Q164 64 180 68 Q204 80 224 116 Q216 124 208 128 Q198 120 188 108 L188 138 Q180 140 172 138 L172 208 Q172 216 164 216 L92 216 Q84 216 84 208 L84 138 Q76 140 68 138 L68 108 Q58 120 48 128 Q40 124 32 116 Q52 80 76 68 Z" />
      <path d="M128 76 Q128 146 128 216" />
    </svg>
  );
}
